import './backToTop.js'

export default {
  init() {
    $(function () {
      // JavaScript to be fired on all category pages

      // Set offset for anchor so it doesn't scroll too far.
      // Smooth scroll anchor
      $('a[href*="#"]:not([href="#"])').click(function () {
        var offset = -150; // <-- change the value here
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top + offset,
            }, 500);
            return false;
          }
        }
      });
    });

  },
  finalize() {
    // JavaScript to be fired on category pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/category.js